import { AdminIssue } from '@/hooks/useAdminIssues';

export function generateLovablePrompt(issue: AdminIssue): string {
  const bugEmoji = issue.type === 'bug' ? '🐛' : issue.type === 'idea' ? '💡' : '✅';
  
  let prompt = `${bugEmoji} ${issue.type.toUpperCase()} - ${issue.title}

**Beskrivelse:**
${issue.description || 'Ingen beskrivelse'}

**Side:** ${issue.page_url}
**Prioritet:** ${issue.priority}
**Status:** ${issue.status}
`;

  // Add error logs if available
  if (issue.error_log && issue.error_log.logs && issue.error_log.logs.length > 0) {
    prompt += `\n**Error Logs (${issue.error_log.totalLogs} fejl):**\n\`\`\`\n`;
    issue.error_log.logs.slice(0, 5).forEach((log: any) => {
      prompt += `[${log.level.toUpperCase()}] ${log.message}\n`;
      if (log.stack) {
        prompt += `  Stack: ${log.stack.split('\n')[0]}\n`;
      }
    });
    prompt += `\`\`\`\n`;
  }

  // Add browser info
  if (issue.user_agent) {
    const isMobile = /mobile|android|iphone|ipad/i.test(issue.user_agent);
    const browser = issue.user_agent.match(/(chrome|firefox|safari|edge)/i)?.[0] || 'Unknown';
    prompt += `\n**Browser:** ${browser}${isMobile ? ' (Mobile)' : ' (Desktop)'}\n`;
  }

  // Add screenshot if available
  if (issue.screenshot_url) {
    prompt += `\n**Screenshot:** ${issue.screenshot_url}\n`;
  }

  // Add tags
  if (issue.tags && issue.tags.length > 0) {
    prompt += `\n**Tags:** ${issue.tags.join(', ')}\n`;
  }

  if (issue.type === 'bug') {
    prompt += `\n**Reproducer:**
1. Gå til: ${issue.page_url}
2. ${issue.description}

**Forventet adfærd:**
[Beskriv hvad der burde ske]

**Faktisk adfærd:**
[Fejlen som beskrevet ovenfor]
`;
  }

  prompt += `\n---
Oprettet: ${new Date(issue.created_at).toLocaleString('da-DK')}
Rapporteret af: ${issue.created_by_email}`;

  return prompt;
}
